/**
 * Safe, side-effect-free deployment-config subpath for operator tooling.
 *
 * Importing the package root starts the Control Plane process, so Setup Server
 * uses this narrow composition facade instead. The typed service remains the
 * only place that validates the document, seals secrets, computes fingerprints,
 * and applies an atomic replacement.
 */
import { createPrisma, disconnectPrisma } from './persistence/prisma.js';
import { PgDeploymentConfigStore } from './persistence/repositories/deployment-config.repo.js';
import { makeSecretCipher } from './secrets/cipher.js';
export { DEFAULT_DEPLOYMENT_CONFIG_VALUES_V1, DEPLOYMENT_CONFIG_SCHEMA_VERSION, DEPLOYMENT_SECRET_KEYS, GITLAB_BASE_URL_LOCKED_REASON, DeploymentConfigConflictError, DeploymentConfigGiteaBaseUrlLockedError, DeploymentConfigGitlabBaseUrlLockedError, DeploymentConfigMissingSecretsError, DeploymentConfigSecretRefreshRequiredError, DeploymentConfigValuesV1Schema, DeploymentSecretKeySchema, DeploymentSecretPatchSchema } from './persistence/deployment-config.js';
export { deploymentAdminClaimKey } from './persistence/deployment-config.js';
/** Open exactly the DB + SecretCipher slice shared by CP and setup tooling. */
export function openDeploymentConfigStore(options) {
    const prisma = createPrisma(options.databaseUrl);
    const store = new PgDeploymentConfigStore(prisma, makeSecretCipher(options), options.gitlabBaseUrl, options.giteaBaseUrl);
    return { store, close: disconnectPrisma };
}
//# sourceMappingURL=deployment-config-store.js.map